<template>
    <el-dialog class="full-transparency" v-model="visible" align-center @close="close" :show-close="false">
        <div class="popup-box">
            <img :src="imgUrl" @load="qrReady = true" alt="">
            <img class="popup-qr" src="/image/qr/qr.png" v-if="showQr && qrReady"
                :style="{ width: qrSize + 'px', height: qrSize + 'px', left: qrLeft + 'px', bottom: qrButtom + 'px' }"
                alt="">
            <div class="close-but" @click.stop="close">
                <el-icon size="28" color="#000">
                    <Close />
                </el-icon>
            </div>
        </div>
    </el-dialog>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { Close } from "@element-plus/icons-vue";

defineProps({
    imgUrl: {
        type: String,
    },
    showQr: {
        type: Boolean,
    },
    qrSize: {
        type: Number,
    },
    qrLeft: {
        type: Number,
    },
    qrButtom: {
        type: Number,
    },
});

const qrReady = ref(false);
const visible = ref(true);

const emits = defineEmits(['closed']);

const close = () => {
    visible.value = false;
    emits('closed');
}

</script>

<style scoped lang="less">
.popup-box {
    position: relative;
    width: min-content;
    height: min-content;
    margin-left: auto;
    margin-right: auto;

    .popup-qr {
        position: absolute;
        border-radius: 18px;
    }

    .close-but {
        width: 28px;
        height: 28px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        position: absolute;
        top: 28px;
        right: 28px;
        z-index: 2;
    }
}
</style>